import { render, staticRenderFns } from "./FeeDetailDialog.vue?vue&type=template&id=472fd761&"
import script from "./FeeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./FeeDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports